import styled from 'styled-components/macro';

/**
 * Flex row
 */
const Row = styled('div')`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export default Row;
